import React, {useContext} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import './PropertyVideos.scss';
import './Adaptations.scss';
import CrusadeBtn from '../../components/crusade/CrusadeBtn';
import { MainContext } from '../../contexts/MainContext';
import VideoPlayer from '../../components/video-player/VideoPlayer';

export default function PropertyVideos(){

  const location = useLocation();

  const {
    allProperties,
    allGroups,
  } = useContext(MainContext);

  const { cityName, communityName, propertyName } = useParams();

  const communityProperties = allProperties.filter(
    (property) => 
      property.path?.startsWith(`/${cityName}/${communityName}/`) &&
      (property.enabled === undefined || property.enabled === true)
  );

  const communityGroupMarkersProperties = allGroups.map(element => element.modal_map_coords_pin.filter( (property) => property.path.startsWith(`/${cityName}/${communityName}/${propertyName}`))).flat();


  const communityMarkers = [ ...communityProperties, ...communityGroupMarkersProperties ];


  const getPropertyLogo = () => {
    const currentPath = location.pathname.replace("/videos", "");
    const property = communityMarkers.find(item => item.path === currentPath);
    return property.logo;
  };

  const getPropertyVideoLinks = () => {
    const currentPath = location.pathname.replace("/videos", "");
    const property = communityMarkers.find((item) => item.path === currentPath);
  
    if (!property || !property.video_link) return [];
  
    const links = Array.isArray(property.video_link) ? property.video_link : [property.video_link];
  
    return links
      .map((link) => {
        const videoIdMatch = link.match(/v=([^&]+)/);
        return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
      })
      .filter(Boolean);
  };
  
  

  return (
    <>
      <div className="videos-container">
        {getPropertyLogo() ? (
            <img
                className="property-logo"
                src={getPropertyLogo()}
                alt="Property Logo"
            />
        ) : (
            <div className="property-logo-text">Ellington</div>
        )}
        <CrusadeBtn />
        <VideoPlayer video_links={getPropertyVideoLinks()}/>
      </div>
    </>
  );
};
